(function () {
    'use strict';

    angular.module("imApp").factory("consignmentPlansService", ['$ihttp', 'p2DataTaskService', function ($ihttp, p2DataTaskService) {
        let service = {
            reloaded: false,
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1361,
                    parameters: parms || {}
                });
            },
            listPlans: function (parms) {
                return $ihttp.post({
                    method: 454,
                    parameters: parms || {}
                });
            },
            updateWidth: function (parms) {
                return $ihttp.post({
                    method: 1457,
                    parameters: parms
                });
            },
            reloadPlans: function () {
                service.reloaded = false;

                setTimeout(() => service.reloaded = true, 15000);

                return service.reloaded;
            },
            updateConsignmentPlans: function (parms) {
                return p2DataTaskService.call(1457, parms);
            }
        };

        return service;
    }]);
})();
